import { render, staticRenderFns } from "./AssetTableSortIcon.vue?vue&type=template&id=173ce918&"
import script from "./AssetTableSortIcon.vue?vue&type=script&lang=js&"
export * from "./AssetTableSortIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports